const guiColors = {
    'motion-primary': '#3C7699',
    'motion-primary-transparent': '#3C7699e6',
    'motion-tertiary': '#305e7a',

    'looks-secondary': '#75C1C4',
    'looks-tertiary': 'hsla(181, 44%, 51%, 1)',
    'looks-transparent': '#75C1C459',
    'looks-light-transparent': '#75C1C426',
    'looks-secondary-dark': 'hsla(181, 44%, 61%, 1)',

    'extensions-primary': 'hsla(203, 44%, 42%, 1)',
    'extensions-tertiary': 'hsla(203, 44%, 25%, 1)',
    'extensions-transparent': 'hsla(203, 44%, 42%, 0.35)',
    'extensions-light': 'hsla(181, 44%, 61%, 1)',

    'drop-highlight': '#5da8cc'
};

const blockColors = {
    checkboxActiveBackground: '#3C7699',
    checkboxActiveBorder: '#305e7a'
};

export {
    guiColors,
    blockColors
};
